import React from "react";

class ProjectsTasksRevisions extends React.Component {

  constructor(props) {
    super(props);
    this.state = {}
  }

 

  render() {
    return (
       <div className="content">
          <div className="row">
            <div className="col-md-12">
            ProjectsTasksRevisions
            </div>
          </div>
        </div>
    );
  }
}

export default ProjectsTasksRevisions;
